<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    siteName() {
      return this.$store.getters.siteName || ''
    }
  },
  watch: {
    siteName: {
      handler(val) {
        document.title = val
      },
      immediate: true
    }
  }
}
</script>
